export const TimeOut = 6000;